<template>
  <div id="customer-table-container">
    <div class="flex-1 flex-row justify-between margin-bottom-4">
      <PlanFilter />
      <div class="flex-1 flex-row justify-end">
        <button
          v-if="showInvite"
          type="button"
          class="primary-button"
          @click="toggleActionModalCustomer(true, 'invite-member')"
        >
          Invite new member
        </button>
      </div>
    </div>
    <div class="ct-container">
      <CategoryMemberTab
        :loading="loading"
        :leftActiveTab="activeProfileTab"
        :leftCategory="categoryOptions"
        :leftToggle="toggleStatusTab"
      />
      <OnboardedCustomers />
    </div>
    <SACTableFooter
      :totalRecords="customerTableOptions.totalItems"
      :rowCount="customerTableOptions.itemsPerPage"
      :page="customerTableOptions.page"
      :changeRowCount="changeRowCount"
      :changePage="changePageCustomer"
      :totalPage="Math.ceil(customerTableOptions.totalItems / customerTableOptions.itemsPerPage)"
      :loading="loading"
    />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import customerMixin from '@shared/mixins/customerMixin';
import SACTableFooter from '@shared/components/table/SACTableFooter.vue';
import CategoryMemberTab from '@shared/components/shared/CategoryMemberTab.vue';
import adminMixin from '@shared/mixins/adminMixin';
import PlanFilter from '@shared/components/customer/PlanFilter.vue';
import OnboardedCustomers from './OnboardedCustomers.vue';

export default {
  name: 'CustomerTable',
  components: {
    PlanFilter,
    OnboardedCustomers,
    CategoryMemberTab,
    SACTableFooter,
  },
  mixins: [customerMixin, customerDetailMixin, adminMixin],
  data() {
    return {
      showInvite: false,
    };
  },
  computed: {
    categoryOptions() {
      const tab = [
        {
          value: 'all',
          label: 'All',
        },
        {
          value: 'complete',
          label: 'Completed Profile',
        },
        {
          value: 'incomplete',
          label: 'Profile Pending',
        },
        {
          value: 'canceled',
          label: 'Canceled',
        },
        {
          value: 'pending',
          label: 'Pending Onboard',
        },
        {
          value: 'pending cancellation',
          label: 'Pending Cancellation',
        },
      ];
      if (this.showInvite) {
        tab.push({
          value: 'invited',
          label: 'Invited Prospects',
        });
      }
      return tab;
    },
  },
  watch: {
    async selectedCorpId() {
      await this.$store.dispatch('getPartnerProviderPlans');
      this.checkInviteFlag();
    },
  },
  async mounted() {
    await this.$store.dispatch('getPartnerProviderPlans');
    this.checkInviteFlag();
  },
  methods: {
    toggleStatusTab(tab) {
      if (!this.loading) {
        this.$store.dispatch('changeCustomerProfileTab', {
          activeTab: tab,
        });
        this.$store.dispatch('changeTableOption', {
          field: 'page',
          value: 1,
        });
      }
      this.$store.dispatch('getAllCustomers');
    },
    async checkInviteFlag() {
      const appOnlyPlans = this.allCorpPlans.find((p) => p.planType === 'AppOnly');
      this.showInvite = !!appOnlyPlans;
    },
  },
};
</script>

<style lang="scss">
#customer-table-container {
  width: 100%;

  @media (max-width: 1600px) {
    max-width: 1400px;
  }
  .ct-select-container {
    margin-bottom: 12px;
  }

  .sh-top-right-buttons {
    display: flex;
    flex-direction: row;
  }

  .ct-header-container {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    justify-content: space-between;

    .ct-header {
      font-size: 1.5625rem;
      color: $N100;
      font-weight: 700;
    }
  }

  .ct-container {
    background-color: $WHITE;
    box-shadow: 0 0 7px 2px rgba(9, 15, 32, 0.02);
    border-radius: 6px;
    padding-bottom: 12px;

    .v-data-table__wrapper {
      height: 700px;
      width: 100%;
      overflow-x: auto;

      thead {
        tr {
          th {
            z-index: 0;
            background-color: $N100;
            color: $WHITE;
            font-size: 15px;
            font-weight: 500;
            text-transform: uppercase;

            .mdi-checkbox-blank-outline::before,
            .mdi-checkbox-marked::before,
            .mdi-minus-box::before,
            .mdi-arrow-up::before {
              color: $WHITE;
            }

            &.sortable {
              i {
                display: none;
              }
            }

            &.active {
              i {
                display: inline-block;
              }
            }
          }
        }
      }

      tbody {
        tr {
          .expand-container {
            padding: 1rem;
            border: 1px solid $LIGHTGRAY;
            background-color: $NBLUE10;
          }

          td {
            border: 0;
          }

          &:hover {
            background: none;
          }

          &:nth-child(even) {
            background-color: $NBLUE5;
          }
        }
      }
    }
  }

  .red-text {
    color: $TOMATO100;
    font-weight: 500;
  }

  .orange-text {
    color: $SUNSET100;
    font-weight: 500;
  }

  .green-text {
    color: $BASIL100;
    font-weight: 500;
  }

  .device-container {
    padding: 10px;
    background-color: $NBLUE10;

    .device-sub-container {
      padding: 10px;
      background-color: $WHITE;
      max-height: 300px;
      overflow: auto;
      position: relative;

      .device-header {
        display: grid;
        width: 100%;
        grid-template-columns: 23% 10% 20% 7% 20% 15%;
        gap: 1rem;
        padding: 10px;
        font-weight: 600;
        text-transform: uppercase;
        background-color: $N1;
        color: $N65;
      }

      .device-data {
        display: grid;
        width: 100%;
        grid-template-columns: 23% 10% 20% 7% 20% 15%;
        gap: 1rem;
        padding: 10px;
        border-top: 1px solid $N10;
      }
    }
  }

  .filter-checkbox {
    margin: 10px 0 10px 0;
  }

  .save-button {
    height: 38px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: solid 4px $NBLUE100;
    background-color: $NBLUE100;
    border-radius: 8px;
    color: $WHITE;
    padding: 0px 16px;
    font-weight: 600;

    &:hover {
      transition: all 280ms ease-in-out;
    }

    &[disabled] {
      opacity: 0.3;
    }
  }
}
</style>
